module.exports = __webpack_public_path__ + "img/usup.cb66a34c.png";